import { render, staticRenderFns } from "./myBank.vue?vue&type=template&id=31c0e5b5&scoped=true&"
import script from "./myBank.vue?vue&type=script&lang=js&"
export * from "./myBank.vue?vue&type=script&lang=js&"
import style0 from "./myBank.vue?vue&type=style&index=0&id=31c0e5b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0e5b5",
  null
  
)

export default component.exports